import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ENTERPRISE_PLATFORM_CAPACITY_MANAGEMENT_OPTIONS } from "../../../utils/constants";
import {
  ENTERPRISE_INTAKE_FIELD_PLATFORM_CAPACITY_MANAGEMENT,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT,
} from "../../../i18n/keysTranslations";
import ReadOnlySectionGrid from "../../PreActivation/components/ReadOnlySectionGrid";
import NumericFieldBlock from "./shared/NumericFieldBlock";
import RadioWithOtherField from "./shared/RadioWithOtherField";
import { mapTranslatedOptions } from "./shared/mapTranslatedOptions";

const UsersSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  const platformCapacityOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_PLATFORM_CAPACITY_MANAGEMENT_OPTIONS,
        t,
      }),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <NumericFieldBlock
        name="platformUsersCount"
        labelKey={ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT}
        required
        min={1}
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <RadioWithOtherField
        name="creditsManagementModel"
        otherName="creditsManagementModelOther"
        labelKey={ENTERPRISE_INTAKE_FIELD_PLATFORM_CAPACITY_MANAGEMENT}
        required
        options={platformCapacityOptions}
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
    </ReadOnlySectionGrid>
  );
};

export default UsersSection;
